// mantine
import { Menu, Table, UnstyledButton } from '@mantine/core';
// components
import { CopyButton, PopoverButton, Truncate } from '@newo/ui-kit';
import { EllipsisVertical, ImagePlay, Trash2 } from 'lucide-react';
import { TProjectImage, TRegistryItemData } from '@newo/api/gateway';
import DateTime from '@/modules/DateTime/components/DateTime';
import ReleaseForm from '@/pages/VersionControl/components/Storages/components/ReleaseForm';

// icons
// utils
import { DATE_FORMAT } from '@/const';

interface ProjectImageProps {
    image: TProjectImage;
    isAdmin: boolean;
    onRelease: (registryId: string, data: TRegistryItemData) => Promise<void>;
    onDelete: (image: TProjectImage) => Promise<void>;
}

const ProjectImage = ({
    image,
    isAdmin,
    onRelease,
    onDelete
}: ProjectImageProps) => {
    const handleDelete = async () => {
        await onDelete(image);
    };

    return (
        <Table.Tr>
            <Table.Td className="truncate">{image.idn}</Table.Td>
            <Table.Td>
                <div className="flex items-center gap-2">
                    <Truncate
                        endLength={4}
                        mode="middle"
                        startLength={4}
                        text={image.image_hash}
                    />
                    <CopyButton value={image.image_hash} />
                </div>
            </Table.Td>
            <Table.Td>
                <DateTime
                    format={DATE_FORMAT.SHORT_12H}
                    value={image.created_at}
                />
            </Table.Td>
            <Table.Td className="text-right">
                <div className="flex justify-end items-center gap-2">
                    {isAdmin ? (
                        <PopoverButton
                            title="Release image"
                            trapFocus={false}
                            trigger={<ImagePlay />}
                        >
                            {(close) => (
                                <ReleaseForm
                                    imageId={image.id}
                                    onClose={close}
                                    onSubmit={onRelease}
                                />
                            )}
                        </PopoverButton>
                    ) : undefined}

                    <Menu withArrow arrowPosition="side">
                        <Menu.Target>
                            <UnstyledButton className="relative left-1">
                                <EllipsisVertical />
                            </UnstyledButton>
                        </Menu.Target>
                        <Menu.Dropdown>
                            <Menu.Item
                                className="text-red-6"
                                leftSection={<Trash2 />}
                                onClick={handleDelete}
                            >
                                Delete
                            </Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                </div>
            </Table.Td>
        </Table.Tr>
    );
};

export default ProjectImage;
